import { Campaign } from './campaign';

export class CampaignDetail {
  campaign: Campaign;
  readMessages: number;
  unreadMessages: number;
}
